import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    "vi": {
        title: "Chọn một bài kiểm tra, nhận kết quả duy nhất dựa trên bạn và chia sẻ nó với bạn bè của bạn!",
        disclaimer: "Khước từ", 
        disclaimer_message: "Tất cả nội dung là cho mục đích giải trí và vui vẻ.",
        share: "Chia sẻ lên Facebook",
        loading_message_1: "Xin vui lòng chờ ...",
        loading_message_2: "Kết quả sẽ làm bạn ngạc nhiên ...",
        may_also_like: "Có thể bạn quan tâm",
        man_or_woman: "Chọn giới tính.",
        man: "Nam",
        woman: "Nữ",
        try_again: "Thử lại",
        nointernetTitle: "Kết nối internet bị mất",
        nointernetButton: "Thử lại",
        inputStep1: "Hiển thị kết quả!",
        inputButton: "Tiếp tục >>",
        err_text: "Lỗi...",
        err_title: "Đã xảy ra lỗi, xin vui lòng thử lại!!!",
        txt_findOut: "Tìm hiểu ngay!",
    },
    "tr": {
        title: "Bir Test seçin, size göre benzersiz bir sonuç alın ve arkadaşlarınızla paylaşın!",
        disclaimer: "feragat", 
        disclaimer_message: "Tüm içerik eğlence ve eğlence amaçlıdır.",
        share: "Paylaş",
        loading_message_1: "Lütfen bekleyin ...",
        loading_message_2: "Sonuç sizi şaşırtacak ...",
        may_also_like: "Ayrıca ilginizi çekebilir",
        man_or_woman: "Sen erkek misin yoksa kadın mı?",
        man: "adam",
        woman: "kadın",
        try_again: "Sonuçlarından memnun değil misin? Tekrar dene",
        nointernetTitle: "İnternet bağlantısı kesildi",
        nointernetButton: "yeniden deneniyor",
        inputStep1: "Sonucunu yükle!",
        inputButton: "Sonucunu görün!",
        err_text: "Hata...",
        err_title: "Bir şeyler ters gitti lütfen tekrar deneyin!!!",
        txt_findOut: "Keşfet!",
    },
    "id": {
        title: "Pilih Tes, dapatkan hasil unik berdasarkan Anda dan bagikan dengan teman-teman Anda!",
        disclaimer: "Penafian",
        disclaimer_message: "Semua konten adalah untuk tujuan hiburan dan kesenangan.",
        share: "Bagikan",
        loading_message_1: "Mohon tunggu ...",
        loading_message_2: "Hasilnya akan mengejutkan Anda ...",
        may_also_like: "Mungkin juga menarik bagi Anda",
        man_or_woman: "Pilih jenis kelamin.",
        man: "Pria",
        woman: "Wanita",
        try_again: "Coba lagi",
        nointernetTitle: "Koneksi internet terputus",
        nointernetButton: "Coba lagi",
        inputStep1: "Muat hasil Anda!",
        inputButton: "Muat hasil Anda!",
        err_text: "Kesalahan...",
        err_title: "Ada yang tidak beres, coba lagi!!!",
         txt_findOut: "Temukan!",
    },
    "th": {
        title: "เลือกการทดสอบรับผลที่ไม่ซ้ำใครจากคุณและแชร์กับเพื่อน ๆ ของคุณ!",
        disclaimer: "คำปฏิเสธ", 
        disclaimer_message: "เนื้อหาทั้งหมดมีวัตถุประสงค์เพื่อความบันเทิงและความสนุกสนาน",
        share: "แบ่งปัน",
        loading_message_1: "โปรดรอ ...",
        loading_message_2: "ผลลัพธ์จะทำให้คุณประหลาดใจ ...",
        may_also_like: "นอกจากนี้ยังอาจสนใจคุณ",
        man_or_woman: "คุณเป็นผู้ชายหรือผู้หญิง?",
        man: "ผู้ชาย",
        woman: "ผู้หญิง",
        try_again: "ลองอีกครั้ง",
        nointernetTitle: "การเชื่อมต่ออินเทอร์เน็ตขาดหายไป",
        nointernetButton: "ลองใหม่",
        inputStep1: "ลองใหม่",
        inputButton: "ลองใหม่",
        err_text: "ข้อผิดพลาด ...",
        err_title: "เกิดข้อผิดพลาดโปรดลองอีกครั้ง!!!",
         txt_findOut: "หาคำตอบ!",
    },
    "it": {
        title: "Scegli un test, ottieni un risultato unico basato su di te e condividilo con i tuoi amici!",
        disclaimer: "disconoscimento", 
        disclaimer_message: "Tutti i contenuti sono a scopo di intrattenimento e divertimento.",
        share: "Condividilo",
        loading_message_1: "Per favore aspetta ...",
        loading_message_2: "Il risultato ti sorprenderà ...",
        may_also_like: "Potrebbe anche interessarti",
        man_or_woman: "Sei un uomo o una donna?",
        man: "uomo",
        woman: "donna",
        try_again: "Riprova",
        nointernetTitle: "La connessione Internet è stata persa",
        nointernetButton: "riprovare",
        inputStep1: "Carica il tuo risultato!",
        inputButton: "Carica il tuo risultato!",
        err_text: "Errore...",
        err_title: "Qualcosa è andato storto. Per favore riprova!!!",
         txt_findOut: "Scoprilo!",
    },
    "ms": {
        title: "Pilih Ujian, dapatkan hasil yang unik berdasarkan anda dan kongsi dengan kawan-kawan anda!",
        disclaimer: "Penafian", 
        disclaimer_message: "Semua kandungan adalah untuk tujuan hiburan dan keseronokan.",
        share: "Kongsi",
        loading_message_1: "Sila tunggu ...",
        loading_message_2: "Hasilnya akan mengejutkan anda ...",
        may_also_like: "Ia juga mungkin menarik minat anda",
        man_or_woman: "Adakah anda lelaki atau perempuan?",
        man: "Lelaki",
        woman: "Wanita",
        try_again: "Cuba lagi",
        nointernetTitle: "Sambungan internet telah hilang",
        nointernetButton: "Cuba semula",
        inputStep1: "Jom ketahui!",
        inputButton: "Jom ketahui!",
        err_text: "Ralat ...",
        err_title: "Ada yang tidak kena, sila cuba lagi!!!",
         txt_findOut: "Find Out!",
    },
    "en": {
        title: "Choose a Test, get a unique result based on you and share it with your friends!",
        disclaimer: "Disclaimer", 
        disclaimer_message: "All content is for entertainment and fun purposes.",
        share: "Share it",
        loading_message_1: "Please wait...",
        loading_message_2: "The result will surprise you ...",
        may_also_like: "You may also like",
        man_or_woman: "Pick a gender.",
        man: "Male",
        woman: "Female",
        try_again: "Try again",
        nointernetTitle: "The internet connection was lost",
        nointernetButton: "Retry",
        inputStep1: "Load your result!",
        inputButton: "See your result!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
        txt_findOut: "Find Out!",
    },
    "bn": {
        title: "Choose a Test, get a unique result based on you and share it with your friends!",
        disclaimer: "Disclaimer", 
        disclaimer_message: "All content is for entertainment and fun purposes.",
        share: "Share it",
        loading_message_1: "Please wait...",
        loading_message_2: "The result will surprise you ...",
        may_also_like: "You may also like",
        man_or_woman: "Pick a gender.",
        man: "Male",
        woman: "Female",
        try_again: "Try again",
        nointernetTitle: "The internet connection was lost",
        nointernetButton: "Retry",
        inputStep1: "Load your result!",
        inputButton: "See your result!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
        txt_findOut: "Find Out!",
    },
    "ps": {
        title: "Choose a Test, get a unique result based on you and share it with your friends!",
        disclaimer: "Disclaimer", 
        disclaimer_message: "All content is for entertainment and fun purposes.",
        share: "Share it",
        loading_message_1: "Please wait...",
        loading_message_2: "The result will surprise you ...",
        may_also_like: "You may also like",
        man_or_woman: "Pick a gender.",
        man: "Male",
        woman: "Female",
        try_again: "Try again",
        nointernetTitle: "The internet connection was lost",
        nointernetButton: "Retry",
        inputStep1: "Load your result!",
        inputButton: "See your result!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
        txt_findOut: "Find Out!",
    },
    "np": {
        title: "Choose a Test, get a unique result based on you and share it with your friends!",
        disclaimer: "Disclaimer", 
        disclaimer_message: "All content is for entertainment and fun purposes.",
        share: "Share it",
        loading_message_1: "Please wait...",
        loading_message_2: "The result will surprise you ...",
        may_also_like: "You may also like",
        man_or_woman: "Pick a gender.",
        man: "Male",
        woman: "Female",
        try_again: "Try again",
        nointernetTitle: "The internet connection was lost",
        nointernetButton: "Retry",
        inputStep1: "Load your result!",
        inputButton: "See your result!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
        txt_findOut: "Find Out!",
    },
    "kk": {
        title: "Choose a Test, get a unique result based on you and share it with your friends!",
        disclaimer: "Disclaimer", 
        disclaimer_message: "All content is for entertainment and fun purposes.",
        share: "Share it",
        loading_message_1: "Please wait...",
        loading_message_2: "The result will surprise you ...",
        may_also_like: "You may also like",
        man_or_woman: "Pick a gender.",
        man: "Male",
        woman: "Female",
        try_again: "Try again",
        nointernetTitle: "The internet connection was lost",
        nointernetButton: "Retry",
        inputStep1: "Load your result!",
        inputButton: "See your result!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
        txt_findOut: "Find Out!",
    },
    "az": {
        title: "Choose a Test, get a unique result based on you and share it with your friends!",
        disclaimer: "Disclaimer", 
        disclaimer_message: "All content is for entertainment and fun purposes.",
        share: "Share it",
        loading_message_1: "Please wait...",
        loading_message_2: "The result will surprise you ...",
        may_also_like: "You may also like",
        man_or_woman: "Pick a gender.",
        man: "Male",
        woman: "Female",
        try_again: "Try again",
        nointernetTitle: "The internet connection was lost",
        nointernetButton: "Retry",
        inputStep1: "Load your result!",
        inputButton: "See your result!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
        txt_findOut: "Find Out!",
    },
    "km": {
        title: "Choose a Test, get a unique result based on you and share it with your friends!",
        disclaimer: "Disclaimer", 
        disclaimer_message: "All content is for entertainment and fun purposes.",
        share: "Share it",
        loading_message_1: "Please wait...",
        loading_message_2: "The result will surprise you ...",
        may_also_like: "You may also like",
        man_or_woman: "Pick a gender.",
        man: "Male",
        woman: "Female",
        try_again: "Try again",
        nointernetTitle: "The internet connection was lost",
        nointernetButton: "Retry",
        inputStep1: "Load your result!",
        inputButton: "See your result!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
         txt_findOut: "Find Out!",
    },
    "fa": {
        title: "Choose a Test, get a unique result based on you and share it with your friends!",
        disclaimer: "Disclaimer", 
        disclaimer_message: "All content is for entertainment and fun purposes.",
        share: "Share it",
        loading_message_1: "Please wait...",
        loading_message_2: "The result will surprise you ...",
        may_also_like: "You may also like",
        man_or_woman: "Pick a gender.",
        man: "Male",
        woman: "Female",
        try_again: "Try again",
        nointernetTitle: "The internet connection was lost",
        nointernetButton: "Retry",
        inputStep1: "Load your result!",
        inputButton: "See your result!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
         txt_findOut: "Find Out!",
    },
    "my": {
        title: "Choose a Test, get a unique result based on you and share it with your friends!",
        disclaimer: "Disclaimer", 
        disclaimer_message: "All content is for entertainment and fun purposes.",
        share: "Share it",
        loading_message_1: "Please wait...",
        loading_message_2: "The result will surprise you ...",
        may_also_like: "You may also like",
        man_or_woman: "Pick a gender.",
        man: "Male",
        woman: "Female",
        try_again: "Try again",
        nointernetTitle: "The internet connection was lost",
        nointernetButton: "Retry",
        inputStep1: "Load your result!",
        inputButton: "See your result!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
         txt_findOut: "Find Out!",
    },
     "te": {
        title: "Choose a Test, get a unique result based on you and share it with your friends!",
        disclaimer: "Disclaimer", 
        disclaimer_message: "All content is for entertainment and fun purposes.",
        share: "Share it",
        loading_message_1: "Please wait...",
        loading_message_2: "The result will surprise you ...",
        may_also_like: "You may also like",
        man_or_woman: "Pick a gender.",
        man: "Male",
        woman: "Female",
        try_again: "Try again",
        nointernetTitle: "The internet connection was lost",
        nointernetButton: "Retry",
        inputStep1: "Load your result!",
        inputButton: "See your result!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
         txt_findOut: "Find Out!",
    },
    "pa": {
        title: "Choose a Test, get a unique result based on you and share it with your friends!",
        disclaimer: "Disclaimer", 
        disclaimer_message: "All content is for entertainment and fun purposes.",
        share: "Share it",
        loading_message_1: "Please wait...",
        loading_message_2: "The result will surprise you ...",
        may_also_like: "You may also like",
        man_or_woman: "Pick a gender.",
        man: "Male",
        woman: "Female",
        try_again: "Try again",
        nointernetTitle: "The internet connection was lost",
        nointernetButton: "Retry",
        inputStep1: "Load your result!",
        inputButton: "See your result!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
         txt_findOut: "Find Out!",
    },
    "ta": {
        title: "Choose a Test, get a unique result based on you and share it with your friends!",
        disclaimer: "Disclaimer", 
        disclaimer_message: "All content is for entertainment and fun purposes.",
        share: "Share it",
        loading_message_1: "Please wait...",
        loading_message_2: "The result will surprise you ...",
        may_also_like: "You may also like",
        man_or_woman: "Pick a gender.",
        man: "Male",
        woman: "Female",
        try_again: "Try again",
        nointernetTitle: "The internet connection was lost",
        nointernetButton: "Retry",
        inputStep1: "Load your result!",
        inputButton: "See your result!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
        txt_findOut: "Find Out!",
    },
    "sw": {
        title: "Choose a Test, get a unique result based on you and share it with your friends!",
        disclaimer: "Disclaimer", 
        disclaimer_message: "All content is for entertainment and fun purposes.",
        share: "Share it",
        loading_message_1: "Please wait...",
        loading_message_2: "The result will surprise you ...",
        may_also_like: "You may also like",
        man_or_woman: "Pick a gender.",
        man: "Male",
        woman: "Female",
        try_again: "Try again",
        nointernetTitle: "The internet connection was lost",
        nointernetButton: "Retry",
        inputStep1: "Load your result!",
        inputButton: "See your result!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
        txt_findOut: "Find Out!",
    },
    "lo": {
        title: "Choose a Test, get a unique result based on you and share it with your friends!",
        disclaimer: "Disclaimer", 
        disclaimer_message: "All content is for entertainment and fun purposes.",
        share: "Share it",
        loading_message_1: "Please wait...",
        loading_message_2: "The result will surprise you ...",
        may_also_like: "You may also like",
        man_or_woman: "Pick a gender.",
        man: "Male",
        woman: "Female",
        try_again: "Try again",
        nointernetTitle: "The internet connection was lost",
        nointernetButton: "Retry",
        inputStep1: "Load your result!",
        inputButton: "See your result!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
        txt_findOut: "Find Out!",
    },
    "he": {
        title: "Choose a Test, get a unique result based on you and share it with your friends!",
        disclaimer: "Disclaimer", 
        disclaimer_message: "All content is for entertainment and fun purposes.",
        share: "Share it",
        loading_message_1: "Please wait...",
        loading_message_2: "The result will surprise you ...",
        may_also_like: "You may also like",
        man_or_woman: "Pick a gender.",
        man: "Male",
        woman: "Female",
        try_again: "Try again",
        nointernetTitle: "The internet connection was lost",
        nointernetButton: "Retry",
        inputStep1: "Load your result!",
        inputButton: "See your result!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
        txt_findOut: "Find Out!",
    },
    "om": {
        title: "Choose a Test, get a unique result based on you and share it with your friends!",
        disclaimer: "Disclaimer", 
        disclaimer_message: "All content is for entertainment and fun purposes.",
        share: "Share it",
        loading_message_1: "Please wait...",
        loading_message_2: "The result will surprise you ...",
        may_also_like: "You may also like",
        man_or_woman: "Pick a gender.",
        man: "Male",
        woman: "Female",
        try_again: "Try again",
        nointernetTitle: "The internet connection was lost",
        nointernetButton: "Retry",
        inputStep1: "Load your result!",
        inputButton: "See your result!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
         txt_findOut: "Find Out!",
    },
    "am": {
        title: "Choose a Test, get a unique result based on you and share it with your friends!",
        disclaimer: "Disclaimer", 
        disclaimer_message: "All content is for entertainment and fun purposes.",
        share: "Share it",
        loading_message_1: "Please wait...",
        loading_message_2: "The result will surprise you ...",
        may_also_like: "You may also like",
        man_or_woman: "Pick a gender.",
        man: "Male",
        woman: "Female",
        try_again: "Try again",
        nointernetTitle: "The internet connection was lost",
        nointernetButton: "Retry",
        inputStep1: "Load your result!",
        inputButton: "See your result!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
         txt_findOut: "Find Out!",
    },
    "ka": {
        title: "Choose a Test, get a unique result based on you and share it with your friends!",
        disclaimer: "Disclaimer", 
        disclaimer_message: "All content is for entertainment and fun purposes.",
        share: "Share it",
        loading_message_1: "Please wait...",
        loading_message_2: "The result will surprise you ...",
        may_also_like: "You may also like",
        man_or_woman: "Pick a gender.",
        man: "Male",
        woman: "Female",
        try_again: "Try again",
        nointernetTitle: "The internet connection was lost",
        nointernetButton: "Retry",
        inputStep1: "Load your result!",
        inputButton: "See your result!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
         txt_findOut: "Find Out!",
    },
    "bg": {
        title: "Choose a Test, get a unique result based on you and share it with your friends!",
        disclaimer: "Disclaimer", 
        disclaimer_message: "All content is for entertainment and fun purposes.",
        share: "Share it",
        loading_message_1: "Please wait...",
        loading_message_2: "The result will surprise you ...",
        may_also_like: "You may also like",
        man_or_woman: "Pick a gender.",
        man: "Male",
        woman: "Female",
        try_again: "Try again",
        nointernetTitle: "The internet connection was lost",
        nointernetButton: "Retry",
        inputStep1: "Load your result!",
        inputButton: "See your result!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
         txt_findOut: "Find Out!",
    },
  
    "mr": {
        title: "Choose a Test, get a unique result based on you and share it with your friends!",
        disclaimer: "Disclaimer", 
        disclaimer_message: "All content is for entertainment and fun purposes.",
        share: "Share it",
        loading_message_1: "Please wait...",
        loading_message_2: "The result will surprise you ...",
        may_also_like: "You may also like",
        man_or_woman: "Pick a gender.",
        man: "Male",
        woman: "Female",
        try_again: "Try again",
        nointernetTitle: "The internet connection was lost",
        nointernetButton: "Retry",
        inputStep1: "Load your result!",
        inputButton: "See your result!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
        txt_findOut: "Find Out!",
    },

    "uk": {
        title: "Виберіть тест, отримайте унікальний результат на основі вас і поділіться ним із друзями!",
        disclaimer: "Disclaimer", 
        disclaimer_message: "All content is for entertainment and fun purposes.",
        share: "Поширити",
        loading_message_1: "Будь ласка, почекайте ...",
        loading_message_2: "Результат вас здивує ...",
        may_also_like: "Найпопулярніші",
        man_or_woman: "Виберіть стать:",
        man: "Чоловіча",
        woman: "Жіноча",
        try_again: "Спробуйте ще раз",
        nointernetTitle: "Інтернет-зв’язок було втрачено",
        nointernetButton: "Повторіть спробу",
        inputStep1: "Дізнатися!",
        inputButton: "Дізнатися!",
        err_text: "Помилка ...",
        err_title: "Щось пішло не так, будь ласка, спробуйте ще раз !!!",
         txt_findOut: "Find Out!",
    },
    "fr": {
        title: "Choisissez un test, obtenez un résultat unique basé sur vous et partagez-le avec vos amis!",
        disclaimer: "Avertissement", 
        disclaimer_message: "Tout le contenu est à des fins de divertissement et d'amusement.",
        share: "Partagez-le",
        loading_message_1: "S'il vous plaît, attendez...",
        loading_message_2: "Le résultat vous surprendra ...",
        may_also_like: "Tu pourrais aussi aimer",
        man_or_woman: "Sélectionnez votre sexe:",
        man: "Masculin",
        woman: "Féminin",
        try_again: "Réessayer",
        nointernetTitle: "La connexion Internet a été perdue",
        nointernetButton: "Recommencez",
        inputStep1: "Chargez votre résultat!",
        inputButton: "Voyez votre résultat!",
        err_text: "Erreur...",
        err_title: "Une erreur s'est produite. Veuillez réessayer!!!",
         txt_findOut: "Find Out!",
    },
    "ph": {
        title: "Pumili ng isang Pagsubok, kumuha ng isang natatanging resulta batay sa iyo at ibahagi ito sa iyong mga kaibigan!",
        disclaimer: "Pagtatanggi", 
        disclaimer_message: "Ang lahat ng nilalaman ay para sa mga libangan at kasiya-siyang layunin.",
        share: "Ibahagi",
        loading_message_1: "Mangyaring maghintay ...",
        loading_message_2: "Ang resulta ay sorpresa ka ...",
        may_also_like: "Maaari mo ring gusto",
        man_or_woman: "Pumili ng isang kasarian.",
        man: "lalaki",
        woman: "babae",
        try_again: "Subukan muli",
        nointernetTitle: "Nawala ang koneksyon sa internet",
        nointernetButton: "Ulitin",
        inputStep1: "I-load ang iyong resulta!",
        inputButton: "Tingnan ang iyong resulta!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
         txt_findOut: "Find Out!",
    },
    "ru": {
        title: "Выберите тест, получите уникальный результат, основанный на вас, и поделитесь им с друзьями!",
        disclaimer: "отказ", 
        disclaimer_message: "Весь контент предназначен для развлекательных и развлекательных целей.",
        share: "Поделись этим",
        loading_message_1: "Пожалуйста, подождите ...",
        loading_message_2: "Результат вас удивит ...",
        may_also_like: "Это также может вас заинтересовать",
        man_or_woman: "Вы мужчина или женщина?",
        man: "человек",
        woman: "женщина",
        try_again: "Попробуйте еще раз",
        nointernetTitle: "Интернет-соединение было потеряно",
        nointernetButton: "Повторная попытка",
        inputStep1: "Загрузите свой результат!",
        inputButton: "Загрузите свой результат!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
         txt_findOut: "Find Out!",
    },
    "ar": {
        title: "اختر اختبارًا واحصل على نتيجة فريدة تعتمد عليك وشاركها مع أصدقائك!",
        disclaimer: "تنصل", 
        disclaimer_message: "جميع المحتويات لأغراض الترفيه والمرح.",
        share: "شاركه",
        loading_message_1: "يرجى الانتظار ...",
        loading_message_2: "والنتيجة ستفاجئك ...",
        may_also_like: "قد يثير اهتمامك أيضًا",
        man_or_woman: "هل انت رجل ام امراه؟",
        man: "رجل",
        woman: "امرأة",
        try_again: " مشاركة",
        nointernetTitle: "تم فقد اتصال الإنترنت",
        nointernetButton: "إعادة المحاولة",
        inputStep1: "أظهري النتيجة!",
        inputButton: "شاهدي النتيجة!",
        err_text: "خطأ...",
        err_title: "حدث خطأ ما. أعد المحاولة من فضلك!!!",
         txt_findOut: "Find Out!",
    },
    "nl": {
        title: "Kies een test, ontvang een uniek resultaat op basis van jou en deel het met je vrienden!",
        disclaimer: "ontkenning", 
        disclaimer_message: "Alle inhoud is voor entertainment en leuke doeleinden.",
        share: "Deel het",
        loading_message_1: "Even geduld aub ...",
        loading_message_2: "Het resultaat zal je verrassen ...",
        may_also_like: "Het kan je ook interesseren",
        man_or_woman: "Ben je een man of een vrouw?",
        man: "man",
        woman: "vrouw",
        try_again: "Probeer het opnieuw",
        nointernetTitle: "De internetverbinding was verloren",
        nointernetButton: "opnieuw proberen",
        inputStep1: "Laad je resultaat!",
        inputButton: "Laad je resultaat!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
         txt_findOut: "Find Out!",
    },
    "de": {
        title: "Wählen Sie einen Test aus, holen Sie sich ein einzigartiges Ergebnis und teilen Sie es mit Ihren Freunden!",
        disclaimer: "Haftungsausschluss", 
        disclaimer_message: "Der gesamte Inhalt dient zur Unterhaltung und zum Spaß.",
        share: "Teilen Sie es",
        loading_message_1: "Bitte warten Sie ...",
        loading_message_2: "Das Ergebnis wird Sie überraschen ...",
        may_also_like: "Es könnte Sie auch interessieren",
        man_or_woman: "Bist du ein Mann oder eine Frau?",
        man: "Mann",
        woman: "Frau",
        try_again: "Versuchen Sie es erneut",
        nointernetTitle: "Die Internetverbindung wurde unterbrochen",
        nointernetButton: "Versuchen Sie es erneut",
        inputStep1: "Laden Sie Ihr Ergebnis!",
        inputButton: "Laden Sie Ihr Ergebnis!",
        err_text: "Error...",
        err_title: "Etwas ist schief gelaufen. Bitte versuche es erneut!!!",
         txt_findOut: "Find Out!",
    },
    "pt": {
        title: "Escolha um Teste, obtenha um resultado único baseado em você e compartilhe com seus amigos!",
        disclaimer: "Isenção de responsabilidade", 
        disclaimer_message: "Todo o conteúdo é para fins de entretenimento e diversão.",
        share: "Compartilhe",
        loading_message_1: "Por favor aguarde ...",
        loading_message_2: "O resultado irá surpreendê-lo ...",
        may_also_like: "Pode também interessar-lhe",
        man_or_woman: "Por favor, selecione um gênero.",
        man: "Masculino",
        woman: "Feminino",
        try_again: "Tente novamente",
        nointernetTitle: "A conexão com a internet foi perdida",
        nointernetButton: "Tente novamente",
        inputStep1: "Carregue o seu resultado!",
        inputButton: "Veja o seu resultado!",
        err_text: "Erro...",
        err_title: "Alguma coisa deu errado. Por favor tente outra vez!!!",
         txt_findOut: "Descubra!",
    },
    "es": {
        title: "¡Elige un Test, obtén un resultado único basado en tí y compártala con sus amigos!",
        disclaimer: "Descargo de Responsabilidad", 
        disclaimer_message: "Todo el contenido es para fines de diversión y entretenimiento.",
        share: "Compartir",
        loading_message_1: "Analizando...",
        loading_message_2: "Los resultados te sorprenderán...",
        may_also_like: "También te puede interesar",
        man_or_woman: "Selecciona tu género.",
        man: "Masculino",
        woman: "Femenino",
        try_again: "Inténtalo de nuevo",
        nointernetTitle: "Se perdió la conexión a internet",
        nointernetButton: "Inténtalo de nuevo",
        inputStep1: "¡Carga tu resultado!",
        inputButton: "¡Mostrar tu resultado!",
        err_text: "Error...",
        err_title: "¡¡¡Algo salió mal. Por favor, vuelva a intentarlo!!!",
         txt_findOut: "¡Descúbrelo!",
    },
    "hi": {
        title: "एक परीक्षण चुनें, आप के आधार पर एक अनूठा परिणाम प्राप्त करें और इसे अपने दोस्तों के साथ साझा करें!",
        disclaimer: "नोटिस", 
        disclaimer_message: "सभी सामग्री मनोरंजन और मजेदार उद्देश्यों के लिए है।",
        share: "साझा कर",
        loading_message_1: "कृपया प्रतीक्षा कीजिये...",
        loading_message_2: "आपको परिणाम से आश्चर्य होगा ...",
        may_also_like: "आपको यह भी पसंद आ सकता है",
        man_or_woman: "तुम पुरुष हो या स्त्री?",
        man: "पुरुष",
        woman: "महिला",
        try_again: "पुनः कोशिश करें",
        nointernetTitle: "इंटरनेट कनेक्शन खो गया था",
        nointernetButton: "पुनः कोशिश करें",
        inputStep1: "अपना रिजल्ट लोड करें!",
        inputButton: "अपना रिजल्ट लोड करें!",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
         txt_findOut: "Find Out!",
    },
    "zh": {
        title: "选择一项测试，根据您获得独特的结果并与您的朋友分享！",
        disclaimer: "放弃", 
        disclaimer_message: "所有内容均用于娱乐和娱乐目的。",
        share: "分享吧",
        loading_message_1: "请稍等......",
        loading_message_2: "结果会让你大吃一惊......",
        may_also_like: "它也可能引起你的兴趣",
        man_or_woman: "你是男人还是女人？",
        man: "男人",
        woman: "女子",
        try_again: "再试一次",
        nointernetTitle: "互联网连接丢失了",
        nointernetButton: "重试",
        inputStep1: "加載你的結果",
        inputButton: "睇睇結果！",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
         txt_findOut: "Find Out!",
    },
    "ur": {
        title: "ٹیسٹ کا انتخاب کریں، آپ کی بنیاد پر ایک منفرد نتیجہ حاصل کریں اور اپنے دوستوں کے ساتھ اشتراک کریں!",
        disclaimer: "ڈس کلیمر", 
        disclaimer_message: "تمام مواد تفریح ​​اور تفریح ​​مقاصد کے لئے ہے.",
        share: "اس کا اشتراک کریں",
        loading_message_1: "براہ مہربانی انتظار کریں ...",
        loading_message_2: "نتیجہ آپ کو تعجب کرے گا ...",
        may_also_like: "یہ آپ کو بھی دلچسپی رکھتا ہے",
        man_or_woman: "کیا آپ مرد یا عورت ہیں؟",
        man: "انسان",
        woman: "عورت",
        try_again: "کیا آپ اپنے نتیجہ سے خوش نہیں ہیں؟ دوبارہ کوشش کریں",
        nointernetTitle: "انٹرنیٹ کنکشن کھو گیا تھا",
        nointernetButton: "دوبارہ کوشش کریں",
        inputStep1: "دوبارہ کوشش کریں",
        inputButton: "دوبارہ کوشش کریں",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
         txt_findOut: "Find Out!",
    },
    "bn": {
        title: "একটি পরীক্ষা চয়ন করুন, আপনার উপর ভিত্তি করে একটি অনন্য ফলাফল পেতে এবং আপনার বন্ধুদের সাথে শেয়ার করুন!",
        disclaimer: "দাবি পরিত্যাগী", 
        disclaimer_message: "সমস্ত কন্টেন্ট বিনোদন এবং মজা উদ্দেশ্যে।",
        share: "এটা শেয়ার করুন",
        loading_message_1: "অনুগ্রহ করে অপেক্ষা করুন ...",
        loading_message_2: "ফলাফল আপনাকে অবাক করবে ...",
        may_also_like: "এটা আপনার আগ্রহ হতে পারে",
        man_or_woman: "আপনি কি একজন পুরুষ নাকি নারী?",
        man: "মানুষ",
        woman: "নারী",
        try_again: "আপনি আপনার ফলাফল খুশি না? আবার চেষ্টা করুন",
        nointernetTitle: "ইন্টারনেট সংযোগ হারিয়ে গেছে",
        nointernetButton: "পুনরায় চেষ্টা করা হচ্ছে",
        inputStep1: "পুনরায় চেষ্টা করা হচ্ছে",
        inputButton: "পুনরায় চেষ্টা করা হচ্ছে",
        err_text: "Error...",
        err_title: "Something went wrong, please try again!!!",
         txt_findOut: "Find Out!",
    }
};

const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages,
});

export default i18n;